export default {
  INVITE_PLAYERS_REQUEST: 'LEADERBOARD_INVITE_PLAYERS_REQUEST',
  INVITE_PLAYERS_SUCCESS: 'LEADERBOARD_INVITE_PLAYERS_SUCCESS',
  INVITE_PLAYERS_FAILURE: 'LEADERBOARD_INVITE_PLAYERS_FAILURE',
  REMOVING_PLAYER: 'LEADERBOARD_REMOVING_PLAYER',
  REMOVED_PLAYER: 'LEADERBOARD_REMOVED_PLAYER',
};
